import type { Product } from '../types/product'
import { images } from './images'

export const livingProducts: Product[] = [
  {
    slug: 'khamsa-ketting',
    line: 'living',
    name: 'Khamsa ketting',
    subtitle: 'Hand van Fatima · 925 zilver',
    category: 'sieraden',
    audiences: [],
    badges: ['bestseller', 'cadeau'],
    image: images.khamsa,
    gallery: [images.khamsa, images.bracelet],
    variants: [
      { id: '42cm', label: '42 cm', price: 49.95 },
      { id: '50cm', label: '50 cm', price: 52.95 },
    ],
    rating: 4.9,
    reviews: 214,
    benefit: 'Een tijdloos symbool van bescherming, fijn gegraveerd.',
    what: 'Hanger in de vorm van de khamsa — de Hand van Fatima — met traditioneel Berber-graveerwerk en een klein turquoise steentje.',
    does: '925 sterling zilver. Hanger ca. 2,8 × 2 cm, aan een fijne schakelketting met karabijnsluiting.',
    use: 'Bewaar droog in het meegeleverde katoenen zakje. Poets af en toe met een zilverdoekje voor blijvende glans.',
  },
  {
    slug: 'berber-armband',
    line: 'living',
    name: 'Berber armband',
    subtitle: 'Met de hand gegraveerd',
    category: 'sieraden',
    audiences: [],
    badges: ['cadeau'],
    image: images.bracelet,
    gallery: [images.bracelet, images.khamsa],
    variants: [
      { id: 's', label: 'S/M', price: 59.95 },
      { id: 'l', label: 'M/L', price: 59.95 },
    ],
    rating: 4.8,
    reviews: 96,
    benefit: 'Statement-armband met Amazigh-motieven.',
    what: 'Brede, open armband met geometrische Amazigh-patronen, met de hand gegraveerd door zilversmeden in de Anti-Atlas.',
    does: 'Verzilverd messing. Breedte ca. 3 cm, licht buigbaar voor een goede pasvorm.',
    use: 'Vermijd contact met parfum en water. Poets met een zacht, droog doekje.',
  },
  {
    slug: 'fibula-oorbellen',
    line: 'living',
    name: 'Fibula oorbellen',
    subtitle: 'Berber zilver met email',
    category: 'sieraden',
    audiences: [],
    badges: ['cadeau'],
    image: images.fibula,
    gallery: [images.fibula, images.ring],
    variants: [{ id: 'std', label: 'Eén maat', price: 39.95 }],
    rating: 4.7,
    reviews: 63,
    benefit: 'Geïnspireerd op de traditionele tizerzai-mantelspeld.',
    what: 'Oorhangers in de vorm van de fibula, de sierspeld waarmee Berbervrouwen hun kleding vastmaakten, met koraalrode en groene emaildetails.',
    does: 'Zilver met email. Lengte ca. 4,5 cm, met haakjes van 925 zilver.',
    use: 'Bewaar apart om krassen te voorkomen. Niet dragen tijdens het douchen of zwemmen.',
  },
  {
    slug: 'amazigh-ring',
    line: 'living',
    name: 'Amazigh ring',
    subtitle: 'Zilver met koraalrode steen',
    category: 'sieraden',
    audiences: [],
    badges: ['nieuw'],
    image: images.ring,
    gallery: [images.ring, images.fibula],
    variants: [
      { id: '16', label: 'Maat 16', price: 34.95 },
      { id: '17', label: 'Maat 17', price: 34.95 },
      { id: '18', label: 'Maat 18', price: 34.95 },
    ],
    rating: 4.7,
    reviews: 41,
    benefit: 'Kleurrijk en uitgesproken, met traditionele inleg.',
    what: 'Robuuste ring met een koraalrode steen, omringd door kleine groene en gele emaildetails in Amazigh-stijl.',
    does: 'Zilver met email en kunstkoraal. Kopbreedte ca. 1,8 cm.',
    use: 'Doe de ring af bij het handen wassen. Poets met een zilverdoekje.',
  },
  {
    slug: 'safi-dinerbord',
    line: 'living',
    name: 'Safi dinerbord',
    subtitle: 'Handbeschilderd · Ø 26 cm',
    category: 'servies',
    audiences: [],
    badges: ['bestseller'],
    image: images.safiPlate,
    gallery: [images.safiPlate, images.livingHero],
    variants: [
      { id: '1', label: '1 stuk', price: 24.95 },
      { id: '4', label: 'Set van 4', price: 89.95, compareAt: 99.8 },
    ],
    rating: 4.9,
    reviews: 188,
    benefit: 'Elk bord met de hand beschilderd — geen twee zijn gelijk.',
    what: 'Dinerbord uit de pottenbakkerijen van Safi, beschilderd met een geometrisch bloemmotief in kobaltblauw, groen en terracotta.',
    does: 'Geglazuurd aardewerk. Ø 26 cm, hoogte ca. 2,5 cm. Voedselveilig glazuur.',
    use: 'Vaatwasserbestendig op een laag programma; handwas houdt de kleuren het mooist. Niet geschikt voor de magnetron.',
  },
  {
    slug: 'fes-serveerschaal',
    line: 'living',
    name: 'Fès serveerschaal',
    subtitle: 'Blauw-wit · Ø 30 cm',
    category: 'servies',
    audiences: [],
    badges: [],
    image: images.fesBowl,
    gallery: [images.fesBowl, images.dishes],
    variants: [{ id: 'std', label: 'Ø 30 cm', price: 44.95 }],
    rating: 4.8,
    reviews: 77,
    benefit: 'De klassieke blauw-witte schaal uit Fès.',
    what: 'Ruime serveerschaal in het beroemde kobaltblauwe Fès-motief, ideaal voor couscous, salades of fruit.',
    does: 'Geglazuurd aardewerk. Ø 30 cm, hoogte ca. 9 cm.',
    use: 'Handwas aanbevolen. Niet geschikt voor oven of magnetron.',
  },
  {
    slug: 'serveertajine',
    line: 'living',
    name: 'Serveertajine',
    subtitle: 'Beschilderd terracotta',
    category: 'servies',
    audiences: [],
    badges: [],
    image: images.tagine,
    gallery: [images.tagine, images.livingHero],
    variants: [
      { id: '25', label: 'Ø 25 cm', price: 49.95 },
      { id: '30', label: 'Ø 30 cm', price: 64.95 },
    ],
    rating: 4.8,
    reviews: 102,
    benefit: 'Zet je gerecht op tafel zoals in Marokko.',
    what: 'Handbeschilderde tajine met kegelvormig deksel, om gerechten warm en sfeervol op tafel te serveren.',
    does: 'Geglazuurd terracotta. Verkrijgbaar in Ø 25 cm en Ø 30 cm.',
    use: 'Alleen voor serveren — niet geschikt voor op het vuur of in de oven. Handwas aanbevolen.',
  },
  {
    slug: 'zellige-schaaltjes',
    line: 'living',
    name: 'Zellige schaaltjes',
    subtitle: 'Set van 6 · Ø 10 cm',
    category: 'servies',
    audiences: [],
    badges: ['nieuw'],
    image: images.dishes,
    gallery: [images.dishes, images.fesBowl],
    variants: [{ id: 'std', label: 'Set van 6', price: 34.95 }],
    rating: 4.7,
    reviews: 58,
    benefit: 'Voor olijven, dips en kruiden — in zellige-kleuren.',
    what: 'Zes kleine schaaltjes in de kleuren van zellige-tegelwerk: kobalt, smaragd, saffraan en terracotta.',
    does: 'Geglazuurd aardewerk. Ø 10 cm per schaaltje.',
    use: 'Vaatwasserbestendig op een laag programma.',
  },
  {
    slug: 'beldi-theeglazen',
    line: 'living',
    name: 'Beldi theeglazen',
    subtitle: 'Set van 6 · goudrand',
    category: 'glazen',
    audiences: [],
    badges: ['bestseller'],
    image: images.teaGlasses,
    gallery: [images.teaGlasses, images.teaset],
    variants: [
      { id: 'goud', label: 'Goud', price: 29.95 },
      { id: 'kleur', label: 'Kleur & goud', price: 32.95 },
    ],
    rating: 4.9,
    reviews: 341,
    benefit: 'Dé glazen voor echte Marokkaanse muntthee.',
    what: 'Zes traditionele theeglazen met sierlijk goudkleurig decor, zoals ze in elk Marokkaans huis op tafel staan.',
    does: 'Glas met decor. Inhoud ca. 150 ml, hoogte 9 cm.',
    use: 'Handwas aanbevolen om het gouddecor te behouden. Niet in de vaatwasser.',
  },
  {
    slug: 'handgeblazen-glazen',
    line: 'living',
    name: 'Handgeblazen beldi-glazen',
    subtitle: 'Gerecycled glas · set van 4',
    category: 'glazen',
    audiences: [],
    badges: [],
    image: images.beldiGlass,
    gallery: [images.beldiGlass, images.teaGlasses],
    variants: [{ id: 'std', label: 'Set van 4', price: 32.95 }],
    rating: 4.8,
    reviews: 119,
    benefit: 'Mondgeblazen, met de karakteristieke luchtbelletjes.',
    what: 'Waterglazen van gerecycled glas, mondgeblazen in Marrakech. Kleine belletjes en vormverschillen maken elk glas uniek.',
    does: 'Gerecycled glas met lichte aqua-tint. Inhoud ca. 300 ml.',
    use: 'Vaatwasserbestendig. Vermijd grote temperatuurverschillen.',
  },
  {
    slug: 'safi-espressokopjes',
    line: 'living',
    name: 'Safi espressokopjes',
    subtitle: 'Set van 2 met schotels',
    category: 'glazen',
    audiences: [],
    badges: ['cadeau'],
    image: images.espresso,
    gallery: [images.espresso, images.safiPlate],
    variants: [{ id: 'std', label: 'Set van 2', price: 24.95 }],
    rating: 4.7,
    reviews: 66,
    benefit: 'Je dagelijkse koffie, met een Marokkaans randje.',
    what: 'Twee handbeschilderde espressokopjes met bijpassende schotels in een kobaltblauw geometrisch patroon.',
    does: 'Geglazuurd aardewerk. Inhoud ca. 90 ml per kopje.',
    use: 'Vaatwasserbestendig op een laag programma.',
  },
  {
    slug: 'marokkaanse-theepot',
    line: 'living',
    name: 'Marokkaanse theepot',
    subtitle: 'Verzilverd · met de hand gegraveerd',
    category: 'thee',
    audiences: [],
    badges: ['bestseller'],
    image: images.teapot,
    gallery: [images.teapot, images.teaset],
    variants: [
      { id: '08', label: '0,8 liter', price: 44.95 },
      { id: '12', label: '1,2 liter', price: 54.95 },
    ],
    rating: 4.8,
    reviews: 157,
    benefit: 'De lange tuit voor de perfecte schenkhoogte.',
    what: 'Traditionele theepot met gegraveerd deksel en lange gebogen tuit — om de thee van hoog te schenken, zodat er een schuimlaagje ontstaat.',
    does: 'Verzilverd roestvrij staal. Inhoud 0,8 of 1,2 liter. Geschikt voor gas en keramische plaat.',
    use: 'Spoel na gebruik om met warm water en droog direct af. Niet in de vaatwasser.',
  },
  {
    slug: 'thee-ceremonie-set',
    line: 'living',
    name: 'Thee-ceremonie set',
    subtitle: 'Theepot, 6 glazen & dienblad',
    category: 'thee',
    audiences: [],
    badges: ['cadeau'],
    image: images.teaset,
    gallery: [images.teaset, images.teapot, images.teaGlasses],
    variants: [{ id: 'set', label: 'Complete set', price: 99.95, compareAt: 119.85 }],
    rating: 4.9,
    reviews: 84,
    benefit: 'Alles voor de Marokkaanse theeceremonie, in één keer.',
    what: 'Een gegraveerde theepot (0,8 l), zes beldi theeglazen met goudrand en een rond gegraveerd dienblad.',
    does: 'Verzilverd staal en glas. Dienblad Ø 35 cm.',
    use: 'Theepot en dienblad met de hand wassen en direct afdrogen. Glazen niet in de vaatwasser.',
    includes: ['marokkaanse-theepot', 'beldi-theeglazen'],
  },
  {
    slug: 'koperen-lantaarn',
    line: 'living',
    name: 'Koperen lantaarn',
    subtitle: 'Handgeponst messing',
    category: 'decoratie',
    audiences: [],
    badges: ['cadeau'],
    image: images.lantern,
    gallery: [images.lantern, images.livingHero],
    variants: [
      { id: 's', label: 'Klein · 30 cm', price: 49.95 },
      { id: 'l', label: 'Groot · 45 cm', price: 69.95 },
    ],
    rating: 4.8,
    reviews: 92,
    benefit: 'Tovert sterrenpatronen op je muren.',
    what: 'Lantaarn van messing, met de hand geponst in sterpatronen. Met een waxinelichtje of led-kaars ontstaat een prachtig lichtspel.',
    does: 'Messing. Hoogte 30 of 45 cm. Met deurtje en draaggreep.',
    use: 'Gebruik bij voorkeur een led-kaars. Afstoffen met een droge doek.',
  },
  {
    slug: 'kilim-kussenhoes',
    line: 'living',
    name: 'Kilim kussenhoes',
    subtitle: 'Handgeweven · 45 × 45 cm',
    category: 'decoratie',
    audiences: [],
    badges: ['nieuw'],
    image: images.kilim,
    gallery: [images.kilim, images.lantern],
    variants: [{ id: 'std', label: '45 × 45 cm', price: 39.95 }],
    rating: 4.7,
    reviews: 48,
    benefit: 'Berber-motieven voor bank of bed.',
    what: 'Handgeweven kussenhoes met Amazigh-ruitmotieven in terracotta, saffraan, crème en indigo.',
    does: 'Wol en katoen. 45 × 45 cm, met rits. Exclusief binnenkussen.',
    use: 'Stomen of voorzichtig met de hand wassen op 30 °C.',
  },
]
